export default function TechIcon({ type, size = 34 }) {
  const icons = {
    /* ── AI & Intelligence ── */
    llm: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="#818CF8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 2a7 7 0 017 7c0 3-2 5.5-4 7l-1 1.5V20h-4v-2.5L9 16c-2-1.5-4-4-4-7a7 7 0 017-7z"/>
        <path d="M9 20h6M10 22h4"/>
        <path d="M10 10c0-1 .5-2 2-2s2 1 2 2-.5 1.5-2 2.5c-1.5-1-2-1.5-2-2.5z" fill="#818CF8" stroke="none"/>
      </svg>
    ),
    rag: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="#818CF8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="3" width="7" height="7" rx="1"/>
        <rect x="14" y="3" width="7" height="7" rx="1"/>
        <rect x="8" y="14" width="8" height="7" rx="1"/>
        <path d="M6.5 10v2l2 2M17.5 10v2l-2 2"/>
      </svg>
    ),
    agent: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="#818CF8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <rect x="4" y="6" width="16" height="12" rx="3"/>
        <circle cx="9.5" cy="12" r="1.5" fill="#818CF8" stroke="none"/>
        <circle cx="14.5" cy="12" r="1.5" fill="#818CF8" stroke="none"/>
        <path d="M8 2l2 4M16 2l-2 4"/>
      </svg>
    ),
    gpt: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="#818CF8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 2l2.4 7.2H22l-6 4.8 2.4 7.2L12 16.4l-6.4 4.8 2.4-7.2-6-4.8h7.6z"/>
      </svg>
    ),
    pgvector: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
        <circle cx="4" cy="5" r="1.5" fill="#818CF8" opacity="0.9"/>
        <circle cx="4" cy="10" r="1.5" fill="#818CF8" opacity="0.35"/>
        <circle cx="4" cy="15" r="1.5" fill="#818CF8" opacity="0.9"/>
        <circle cx="4" cy="19" r="1.5" fill="#818CF8" opacity="0.9"/>
        <circle cx="9" cy="5" r="1.5" fill="#818CF8" opacity="0.9"/>
        <circle cx="9" cy="10" r="1.5" fill="#818CF8" opacity="0.9"/>
        <circle cx="9" cy="15" r="1.5" fill="#818CF8" opacity="0.35"/>
        <circle cx="9" cy="19" r="1.5" fill="#818CF8" opacity="0.9"/>
        <circle cx="14" cy="5" r="1.5" fill="#818CF8" opacity="0.35"/>
        <circle cx="14" cy="10" r="1.5" fill="#818CF8" opacity="0.9"/>
        <circle cx="14" cy="15" r="1.5" fill="#818CF8" opacity="0.9"/>
        <circle cx="14" cy="19" r="1.5" fill="#818CF8" opacity="0.9"/>
        <circle cx="19" cy="5" r="1.5" fill="#818CF8" opacity="0.9"/>
        <circle cx="19" cy="10" r="1.5" fill="#818CF8" opacity="0.9"/>
        <circle cx="19" cy="15" r="1.5" fill="#818CF8" opacity="0.9"/>
        <circle cx="19" cy="19" r="1.5" fill="#818CF8" opacity="0.35"/>
        <path d="M4 5l15 14" stroke="#818CF8" strokeWidth="1.5" strokeLinecap="round" opacity="0.4"/>
      </svg>
    ),
    orchestration: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="#818CF8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="5" r="3"/><circle cx="5" cy="19" r="3"/><circle cx="19" cy="19" r="3"/>
        <path d="M12 8v3M9 14l-2 3M15 14l2 3"/>
        <circle cx="12" cy="12.5" r="1.5" fill="#818CF8" stroke="none"/>
      </svg>
    ),
    /* ── Frontend ── */
    react: (
      <svg width={size} height={size} viewBox="-12 -12 24 24">
        <circle r="2.2" fill="#61DAFB"/>
        <g fill="none" stroke="#61DAFB" strokeWidth="1">
          <ellipse rx="10" ry="4.4"/>
          <ellipse rx="10" ry="4.4" transform="rotate(60)"/>
          <ellipse rx="10" ry="4.4" transform="rotate(120)"/>
        </g>
      </svg>
    ),
    nextjs: (
      <svg width={size} height={size} viewBox="0 0 24 24">
        <circle cx="12" cy="12" r="11" fill="#000" stroke="none"/>
        <path d="M9.5 8v8M9.5 8l7.5 10" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
        <path d="M17 8v5" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" fill="none"/>
      </svg>
    ),
    flutter: (
      <svg width={size} height={size} viewBox="0 0 24 24">
        <path d="M14 2L4 12l3.5 3.5L22 2H14z" fill="#42A5F5"/>
        <path d="M14 12L7.5 18.5 11 22h7l-7-7 7-7h-4z" fill="#42A5F5"/>
        <path d="M11 22l3-3.5L10.5 15l-3 3.5z" fill="#1565C0"/>
      </svg>
    ),
    tailwind: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="#06B6D4">
        <path d="M12 6c-2.67 0-4.33 1.33-5 4 1-1.33 2.17-1.83 3.5-1.5.76.19 1.3.74 1.9 1.35C13.35 10.82 14.5 12 17 12c2.67 0 4.33-1.33 5-4-1 1.33-2.17 1.83-3.5 1.5-.76-.19-1.3-.74-1.9-1.35C15.65 7.18 14.5 6 12 6zM7 12c-2.67 0-4.33 1.33-5 4 1-1.33 2.17-1.83 3.5-1.5.76.19 1.3.74 1.9 1.35C8.35 16.82 9.5 18 12 18c2.67 0 4.33-1.33 5-4-1 1.33-2.17 1.83-3.5 1.5-.76-.19-1.3-.74-1.9-1.35C10.65 13.18 9.5 12 7 12z"/>
      </svg>
    ),
    redux: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="#764ABC">
        <path d="M16.6 16.8c1-.1 1.7-1 1.6-2-.1-1-1-1.7-2-1.6s-1.7 1-1.6 2c.1.9.8 1.5 1.6 1.6h.4zm.6 1.4c-1.2.3-2.2-.2-2.8-1.1-.8.3-1.5.4-2.3.4-3.6-.1-6.5-3.1-6.5-6.8 0-1.7.6-3.3 1.8-4.5C8.5 5.1 9.7 4.5 11 4.3c-.2-.5-.4-1-.4-1.6 0-1.5 1.2-2.7 2.7-2.7 1.5 0 2.7 1.2 2.7 2.7 0 .6-.2 1.1-.4 1.6 2.3.5 4.1 2.2 4.8 4.4.7-.2 1.5-.1 2.1.4.9.7 1 1.9.4 2.8-.5.7-1.3 1-2.1.9-.3 2.5-2 4.5-4.3 5.2l-.3.2z"/>
      </svg>
    ),
    pwa: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="#5A0FC8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <rect x="5" y="2" width="14" height="20" rx="3"/>
        <circle cx="12" cy="18" r="1" fill="#5A0FC8" stroke="none"/>
        <path d="M9 9l3-3 3 3M12 6v7"/>
      </svg>
    ),
    /* ── Backend ── */
    nodejs: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="#339933">
        <path d="M12 1.5l9.5 5.5v11L12 23.5 2.5 18V7L12 1.5z" opacity="0.15"/>
        <path d="M12 1.5l9.5 5.5v11L12 23.5 2.5 18V7L12 1.5z" fill="none" stroke="#339933" strokeWidth="1.2"/>
        <text x="12" y="14.5" textAnchor="middle" fill="#339933" fontSize="8" fontFamily="'DM Sans', sans-serif" fontWeight="700">N</text>
      </svg>
    ),
    python: (
      <svg width={size} height={size} viewBox="0 0 24 24">
        <path d="M11.9 1C7.5 1 8 2.8 8 2.8l.01 2.6H12v.8H4.6S1 5.7 1 11.8s3.1 5.9 3.1 5.9h1.9v-2.9s-.1-3.1 3-3.1h5.2s3 0 3-2.9V4.3S17.6 1 11.9 1zm-2.8 2a1 1 0 110 2 1 1 0 010-2z" fill="#3776AB"/>
        <path d="M12.1 23c4.4 0 3.9-1.8 3.9-1.8l-.01-2.6H12v-.8h7.4s3.6.4 3.6-5.7-3.1-5.9-3.1-5.9h-1.9v2.9s.1 3.1-3 3.1H9.8s-3 0-3 2.9v4.5S6.4 23 12.1 23zm2.8-2a1 1 0 110-2 1 1 0 010 2z" fill="#FFD43B"/>
      </svg>
    ),
    postgresql: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="#4169E1">
        <path d="M17.1 2.6c-1.5-.6-3.2-.8-4.8-.6-1.6.2-3 .8-4.2 1.7C6.6 5 5.5 7 5.2 9.3c-.2 1.5 0 3.1.5 4.5l-.3 4c0 .4.1.7.4 1 .3.2.6.3 1 .2l3.4-.8c1 .4 2.2.6 3.3.5 1.7-.1 3.3-.8 4.5-1.9 1.2-1.1 2-2.6 2.3-4.2.3-1.8 0-3.6-.8-5.2-.5-1-.8-2.3-1.4-3.2-.5-.7-1-1.2-1-1.6z"/>
        <ellipse cx="10" cy="8.5" rx="1.2" ry="1.5" fill="#fff"/>
        <ellipse cx="14.5" cy="8.5" rx="1.2" ry="1.5" fill="#fff"/>
        <path d="M17.5 12c-.3 1.3-1.2 2-2.5 2.2v3c0 1.5.5 2.3 1.8 2.5" fill="none" stroke="#336791" strokeWidth="1"/>
      </svg>
    ),
    mongodb: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="#47A248">
        <path d="M12.5 2.1s-1.2 1.6-1.4 2.1c-2 4.5-.4 7.5.8 9.5.2.3.3.5.4.8l.2 1v6c0 .2.2.4.4.5h.2c.2 0 .4-.2.4-.5v-6l.2-1c.1-.3.2-.5.4-.8 1.2-2 2.8-5 .8-9.5-.3-.5-1.4-2.1-1.4-2.1z"/>
      </svg>
    ),
    rest: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="#C084FC" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M7 8l-4 4 4 4"/>
        <path d="M17 8l4 4-4 4"/>
        <path d="M14 4l-4 16"/>
      </svg>
    ),
    graphql: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="#E10098">
        <path d="M12 2l8.7 5v10L12 22l-8.7-5V7L12 2z" fill="none" stroke="#E10098" strokeWidth="1.2"/>
        <circle cx="12" cy="2" r="1.5"/><circle cx="20.7" cy="7" r="1.5"/>
        <circle cx="20.7" cy="17" r="1.5"/><circle cx="12" cy="22" r="1.5"/>
        <circle cx="3.3" cy="17" r="1.5"/><circle cx="3.3" cy="7" r="1.5"/>
      </svg>
    ),
    websockets: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="#C084FC" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 12h3l2-6 3 12 2-9 2 3h4"/>
        <circle cx="4" cy="12" r="1.5" fill="#C084FC" stroke="none"/>
        <circle cx="20" cy="12" r="1.5" fill="#C084FC" stroke="none"/>
      </svg>
    ),
    /* ── Infrastructure ── */
    aws: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="#FF9900">
        <path d="M6.8 14.5c-2.5-1.3-4.2-3.3-4.2-5 0-3.2 4.2-5.8 9.4-5.8s9.4 2.6 9.4 5.8c0 1.7-1.7 3.7-4.2 5"/>
        <path d="M2 14.5c2.5 2 6 3.2 10 3.2s7.5-1.2 10-3.2" fill="none" stroke="#FF9900" strokeWidth="1.5" strokeLinecap="round"/>
        <path d="M18 16l3.5-1.5L22 18" fill="none" stroke="#FF9900" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
    docker: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="#2496ED">
        <path d="M22 9.4c-.5-.3-1.5-.5-2.4-.3-.2-1.2-1-2.2-2-2.9l-.4-.3-.3.4c-.4.6-.6 1.3-.5 2 0 .5.2 1 .4 1.4-.6.3-1.7.5-3.1.5H1l-.1.6c-.1 1.4.1 2.9.8 4.2 1 1.7 2.5 2.6 4.7 2.6 4.4 0 7.6-2 9.2-5.7 1 0 2-.2 2.6-1l.2-.3-.4-.2z"/>
        <g fill="#2496ED" stroke="#fff" strokeWidth=".5">
          <rect x="7" y="5.2" width="2.5" height="2.3" rx=".3"/>
          <rect x="10" y="5.2" width="2.5" height="2.3" rx=".3"/>
          <rect x="13" y="5.2" width="2.5" height="2.3" rx=".3"/>
          <rect x="10" y="2.6" width="2.5" height="2.3" rx=".3"/>
          <rect x="4" y="7.8" width="2.5" height="2.3" rx=".3"/>
          <rect x="7" y="7.8" width="2.5" height="2.3" rx=".3"/>
          <rect x="10" y="7.8" width="2.5" height="2.3" rx=".3"/>
          <rect x="13" y="7.8" width="2.5" height="2.3" rx=".3"/>
        </g>
      </svg>
    ),
    cicd: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="#F59E0B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M18.2 8.5c1.6 1.6 1.6 5.4 0 7s-5.4 1.6-7 0"/>
        <path d="M5.8 15.5c-1.6-1.6-1.6-5.4 0-7s5.4-1.6 7 0"/>
        <path d="M15 5l3.2 3.5L15 12"/>
        <path d="M9 19l-3.2-3.5L9 12"/>
      </svg>
    ),
    kubernetes: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="#326CE5">
        <path d="M12 1l10 5.8v10.4L12 23 2 17.2V6.8L12 1z" fill="none" stroke="#326CE5" strokeWidth="1.2"/>
        <circle cx="12" cy="12" r="3" fill="none" stroke="#326CE5" strokeWidth="1.2"/>
        <line x1="12" y1="3" x2="12" y2="9" stroke="#326CE5" strokeWidth="1"/>
        <line x1="12" y1="15" x2="12" y2="21" stroke="#326CE5" strokeWidth="1"/>
        <line x1="4" y1="7.5" x2="9.5" y2="10.5" stroke="#326CE5" strokeWidth="1"/>
        <line x1="14.5" y1="13.5" x2="20" y2="16.5" stroke="#326CE5" strokeWidth="1"/>
        <line x1="4" y1="16.5" x2="9.5" y2="13.5" stroke="#326CE5" strokeWidth="1"/>
        <line x1="14.5" y1="10.5" x2="20" y2="7.5" stroke="#326CE5" strokeWidth="1"/>
      </svg>
    ),
    cloud: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="#F59E0B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M18 10h1a4 4 0 010 8H6a5 5 0 01-.8-9.9A7 7 0 0118 10z"/>
      </svg>
    ),
    security: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="#F59E0B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 2l8 4v5c0 5.5-3.4 10.3-8 12-4.6-1.7-8-6.5-8-12V6l8-4z"/>
        <path d="M9 12l2 2 4-4"/>
      </svg>
    ),
  };

  return icons[type] || null;
}
